import React from 'react';
import { parseDate } from '../../utils/date-utils';

const useDatePicker = (date) => {
  const [selectedDate, setSelectedDate] = React.useState();
  React.useEffect(() => {
    date && setSelectedDate(parseDate(date));
  }, []);
  return [selectedDate, setSelectedDate];
};

export default useDatePicker;
